import script from "./AudienceIntegrationsItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceIntegrationsItem.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceIntegrationsItem.vue?vue&type=style&index=0&id=2a2cf06b&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2cf06b"]])

export default __exports__